import { useUser } from 'components/user-context'
import { Constants } from 'constants/constants'
import { isEntitled } from 'utils/helpers'
import { useDeviceInfo } from './useDeviceInfo'
import { useEssentials } from './useEssentials'

export const useRestricted = () => {
    const { userAgent } = useEssentials()
    const { greenfieldGroups } = useUser()
    const { ADMIN_PROD, BETA, POWERUSER } = Constants.GREENFIELD_GROUPS
    const isBetaEntitled = isEntitled(greenfieldGroups ?? [], [
        BETA,
        ADMIN_PROD,
    ])
    // PowerUser Entitlement is used for Personal Device permissions
    const isPowerUserEntitled = isEntitled(greenfieldGroups ?? [], [
        POWERUSER,
        ADMIN_PROD,
    ])
    let { isZebraDevice } = useDeviceInfo(userAgent)

    return {
        betaAccess: isBetaEntitled,
        powerUserAccess: isPowerUserEntitled,
        isZebraDevice,
    }
}
